import React, { StrictMode, useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import GCFilters from "./grid-cards-filters.jsx";
import GCPages from "./grid-cards-pagination.jsx";
import jQuery, { data } from "jquery";
import {
  onViewChange,
  allToTallest,
  allToShortest,
} from "@/resources/assets/js/modules/utils";

function CardBlog({ item }) {
  return (
    <div className={`CardBlog${item.isFeatured ? " CardBlog--featured" : ""}`}>
      <div className="CardBlog-image">
        <img
          src={item.imageSrc}
          alt={`${item.title} image`}
          width="100%"
          height="210"
        />
      </div>

      <div className="CardBlog-body">
        {item.isFeatured && <span>Featured post</span>}
        <p className="category">{item.category}</p>
        <h3 className={item.isFeatured ? "featured" : ""}>{item.title}</h3>
        <p>{item.intro}</p>
      </div>

      <a
        className="u-fillLink"
        href={item.link}
        aria-label={`Click this button to go to ${item.title} post`}
      >
        <span className="sr-only">{`Click this button to go to ${item.title} post`}</span>
      </a>
    </div>
  );
}

function GridCards(props) {
  return (
    <div className="GCGrid-rail">
      {props.cards.map((card) => (
        <CardBlog item={card} key={card.id} />
      ))}
    </div>
  );
}

function Spinner(props) {
  return (
    <div className="Spinner" style={props.extraStyle}>
      <svg viewBox="0 0 36 36" height="36" width="36">
        <circle cx="18" cy="18" r="14" fill="none"></circle>
      </svg>
    </div>
  );
}

function NoResults({ noResults }) {
  return (
    <p className={`GCGrid-notFound ${noResults ? "hide" : ""}`}>
      Sorry, nothing was found.
    </p>
  );
}

function pageNumberFromLocation() {
  const pathMatch = window.location.pathname.match(/\/page\/(\d+)\/?$/);
  if (pathMatch) {
    return parseInt(pathMatch[1], 10);
  }

  const queryPage = new URL(window.location.href).searchParams.get("page");
  if (queryPage && /^\d+$/.test(queryPage)) {
    return parseInt(queryPage, 10);
  }

  return 1;
}

function App() {
  const initialPage = pageNumberFromLocation();
  const query = {
    post_type: globals.archivePostType,
    featured_posts: globals.featuredPosts || "false",
    terms: [],
    page_num: 1,
    current_page: initialPage,
    request_number: 0,
  };
  const [loading, setLoading] = useState(false);
  const [requestNumber, setRequestNumber] = useState(0);
  const [cards, setCards] = useState([]);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    resizeCards(document.querySelector(".GCGrid-rail"));
  });

  useEffect(() => {
    init();
  }, []);

  function init() {
    const filterButton = document.getElementById("filterCards");
    const url = window.location.href;
    const newUrl = url + "&load";
    window.history.replaceState(null, null, newUrl);
    filterButton.click(true);
  }

  function resizeCards(allCards) {
    const cardsTitles = [
      ...allCards.querySelectorAll(".CardBlog-body h3:not(.featured)"),
    ];
    const cardsIntro = [
      ...allCards.querySelectorAll(".CardBlog-body > p:nth-child(2)"),
    ];
    if (cardsTitles.length && window.innerWidth > 575) {
      allToTallest(cardsTitles);
      allToTallest(cardsIntro);
      onViewChange(allToTallest.bind(this, cardsTitles));
      onViewChange(allToTallest.bind(this, cardsIntro));
    }
  }

  function _fetch() {
    query.page_num = pageNumberFromLocation();
    setLoading(true);
    setRequestNumber(requestNumber + 1);

    query.request_number = requestNumber;

    // console.log(query);

    const xhr = jQuery.ajax({
      type: "GET",
      url: `${globals.siteRoot}wp-json/aly/v1/cards/list`,
      data: {
        ...query,
      },
    });

    xhr.done((data) => {
      setLoading(false);

      setCurrentPage(data.data.pagination.currentPage);
      setTotalPages(data.data.pagination.totalPages);

      setCards(data.data.items);
    });

    xhr.fail((data) => {
      console.log(`GridPosts error:`);
      console.log(data);
    });
  }

  function update(args) {
    // if (!this.loaded) return;
    Object.entries(args).forEach(
      ([key, value]) => query[key] && (query[key] = value)
    );

    _fetch();
  }

  return (
    <>
      <GCFilters update={update} />
      <section className={`GCGrid u-viewed ${loading ? "u-isLoading" : ""}`}>
        <Spinner
          extraStyle={
            loading
              ? { opacity: 1, pointerEvents: "all" }
              : { opacity: 0, pointerEvents: "none" }
          }
        />
        <div className="GCGrid-rail">
          <NoResults noResults={cards.length} />
          <GridCards cards={cards} />
        </div>
      </section>
      <GCPages
        update={update}
        totalPages={totalPages}
        currentPage={currentPage}
      />
    </>
  );
}

[...document.querySelectorAll(".GridCards")].forEach((grid) => {
  const root = ReactDOM.createRoot(document.getElementById("GridCards"));
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
